import { handleActions } from "redux-actions";

import { defaultState } from "../configureStore";

export default handleActions(
  {
    FLYER_GET: {
      PENDING: () => ({ flyer: { ...defaultState.flyer, isLoading: true } }),
      FULFILLED: (_state, action) => ({
        flyer: action.payload.flyer,
      }),
      REJECTED: (state) => ({
        flyer: { ...state.flyer, isLoading: false, isError: true },
      }),
    },

    FLYER_DELETE: {
      FULFILLED: ({ asset }) => ({
        asset: { ...asset, flyer: undefined },
        flyer: {},
      }),
    },
  },
  {},
  { namespace: "_" }
);
